/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { assert } from "@ember/debug";
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { modifier } from "ember-modifier";
import $ from "jquery";
import { dateFormat } from "parog-web/helpers/datepicker-format";

export interface Signature {
  Element: HTMLDivElement;
  Args: {
    disabled?: unknown;
    selected?: Date;
    settings: {
      type: string;
    };
    format: string;
    isReadOnly: boolean;
    onFocusOut: (value?: Date) => void;
  };
}

interface HTMLCalendarElement extends JQuery {
  calendar(command: string, value?: Date): void;
}

export default class FuiCalendarComponent extends Component<Signature> {
  currentValue = this.selected;
  get placeholder() {
    switch (this.args.settings.type) {
      case "month":
        return "ex. : 01/2007";
      case "year":
        return "ex. : 2007";
      case "time":
        return "ex. : 12:00";
      default:
        return "ex. : 09/01/2017";
    }
  }

  get selected(): Date | undefined {
    if (
      typeof this.args.selected == "string" &&
      !isNaN(Date.parse(this.args.selected))
    ) {
      return new Date(this.args.selected);
    }
    return this.args.selected;
  }

  @action
  _setDateCalendar(calendar) {
    assert(
      "args.selected must be a date, a date string or undefined",
      this.selected instanceof Date || this.selected == undefined
    );
    ($(calendar) as HTMLCalendarElement).calendar("set date", this.selected);
  }

  setDateCalendar = modifier(this._setDateCalendar);

  @action
  focusOut() {
    this.args.onFocusOut?.(this.currentValue);
  }

  @action
  onChange(value: Date) {
    this.currentValue = value;
  }

  @action
  onShow() {
    return this.args.isReadOnly !== true;
  }

  get settings() {
    return Object.assign(
      {},
      {
        selectAdjacentDays: true,
        firstDayOfWeek: 1,
        monthFirst: false,
        text: {
          days: ["D", "L", "M", "Me", "J", "V", "S"],
          months: [
            "Janvier",
            "Février",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Août",
            "Septembre",
            "Octobre",
            "Novembre",
            "Décembre"
          ],
          monthsShort: [
            "Janv",
            "Févr",
            "Mars",
            "Avr",
            "Mai",
            "Juin",
            "Juil",
            "Août",
            "Sept",
            "Oct",
            "Nov",
            "Déc"
          ],
          today: "Aujourd'hui",
          now: "Maintenant"
        },
        onChange: this.onChange,
        onHide: this.focusOut,
        onShow: this.onShow,
        formatter: {
          date: dateFormat
        }
      },
      this.args.settings
    );
  }

  get format() {
    return this.args.format || "default";
  }
}
